import page from './page'
import matrix from './matrix'
import appList from './app-list'
import latex from './latex'

export default {
    install: function (Vue) {
        Vue.component('my-page', page)
        Vue.component('matrix', matrix)
        Vue.component('app-list', appList)
        Vue.component('latex', latex)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js